import { useEffect } from 'react'
import { Navigate, Routes } from 'react-router-dom'
import { useAuth } from './core/AuthProvider'

export function Logout() {
  const { logout } = useAuth()
  useEffect(() => {
    logout()
  }, [logout])

  return (
    <Routes>
      <Navigate to='/auth/login' />
    </Routes>
  )
}
